import Bugsnag from '@bugsnag/js';
import { isFeatureEnabled, waitTillAvailable } from '@vp/ab-reader';
import { Criteria, validateAllCriteria } from './criteria';

export async function getVistaFeatureFlag(flag: string, criteria: Criteria[]): Promise<boolean> {
    if (!validateAllCriteria(criteria)) {
        return false;
    }

    const available = await waitTillAvailable(3000);
    if (!available) {
        Bugsnag.notify(new Error('AB reader is not available'), (event) => {
            event.severity = 'error';
            event.addMetadata('getVistaFeatureFlag', { flag, criteria });
        });
        return false;
    }

    return isFeatureEnabled(flag);
}
